module.exports = __webpack_public_path__ + "img/reset-password.10ff09ad.jpg";